<template>
	<div ref="chartRef" class="chartdiv" style="width: 100%; height: 100%"></div>
</template>

<script setup>
import { defineProps, ref, onMounted, onUnmounted } from 'vue';
import * as am5 from '@amcharts/amcharts5';
import * as am5wc from '@amcharts/amcharts5/wc';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';

const props = defineProps(['chartText']);
const chartRef = ref(null);

onMounted(() => {
	const root = am5.Root.new(chartRef.value);
	root.setThemes([am5themes_Animated.new(root)]);

	const series = root.container.children.push(am5wc.WordCloud.new(root, {}));
	const data = props.chartText;
	if (data && data.length > 0) {
		series.labels.template.setAll({
			paddingTop: 5,
			paddingBottom: 5,
			paddingLeft: 5,
			paddingRight: 5,
			fontFamily: 'Courier New',
			fill: '#7ab4e7',
		});
		series.setAll({
			maxCount: 100,
			minWordLength: 2,
			maxFontSize: am5.percent(35),
			minFontSize: am5.percent(10),
			text: data,
			autoResize: true,
		});
	}
});

onUnmounted(() => {
	am5.array.each(am5.registry.rootElements, root => {
		if (root.dom.className === 'chartdiv') {
			root.dispose();
		}
	});
});
</script>

<style scoped lang="scss"></style>
